import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

//declare var require: any;

@Injectable()
export class LibraryInjectorService {
    private isServer:boolean;
    protected library;
    /**
     * LibraryInjectorService: Exposes javascript libraries defined through AMD/require;
     */
    constructor(@Inject(PLATFORM_ID) private platformId: string) {
        this.isServer = isPlatformServer(this.platformId);
        this.library = null;
    }

    public getClientLibrary(name): any {
          if (!this.isServer){
              this.setLibraryToReturn(name);
          }
          return this.library;
    }

    private setLibraryToReturn(key: string){
        //console.log('setting library for ...')
        //console.log(key);

        switch (key) {
            case 'masonry-layout':
                this.library = require('masonry-layout');
                break;
            case 'imagesLoaded':
                this.library = require('imagesloaded');
                break;
            default:
                this.library = null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/util/library-injector.service.ts